module.exports = __webpack_public_path__ + "static/img/cv.f9922e01.svg";